import * as intrasyncExports from '@intrasync/utils';
import { uriToCamel } from '@intrasync/utils';

// Internal functions no longer publicly exported from @intrasync/utils v26.3.0
const servicePathToStoreName = (servicePath: string): string =>
  `${uriToCamel(servicePath)}Store`;

const productTypeKeys = {
  C: 'Concrete',
  T: 'Thinshell',
  G: 'GFRC',
} as const;

export const utils = {
  ...intrasyncExports,
  servicePathToStoreName,
  productTypeKeys,
};

// Re-export all named exports for pass-through compatibility
export * from '@intrasync/utils';
